import { getConfig } from '@sortlist-frontend/config';
import { isBrowser, useScript } from '@sortlist-frontend/utils';

// See https://developers.google.com/maps/documentation/javascript/libraries
export type Libraries = 'places' | 'drawing' | 'geometry' | 'visualization' | 'geocoding';

export const LIBRARIES: Libraries[] = ['places', 'drawing', 'geometry', 'visualization', 'geocoding'];

export const ON_GOOGLE_SCRIPT_LOAD = 'onGoogleScriptLoad';

export const useGooglePlacesApi = ({
  libraries = LIBRARIES,
  locale = 'en',
  async = true,
  callbackName,
}: {
  libraries?: Libraries[];
  locale?: string;
  async?: boolean;
  callbackName?: string;
}) => {
  const { publicEnv } = getConfig();
  const { googlePlaceApiKey } = publicEnv;

  const state = useScript(
    `https://maps.googleapis.com/maps/api/js?libraries=${libraries.join(',')}&key=${googlePlaceApiKey}&region=EU&language=${locale}&${callbackName != null ? 'callback=' + callbackName : ''}&${async ? 'loading=async' : ''}`,
    {
      disabled: googlePlaceApiKey == null,
      async: true,
    },
  );

  return {
    done: state === 'success' && isBrowser() && window.google != null,
  };
};
